import { render, staticRenderFns } from "./OutputsTable.vue?vue&type=template&id=40b65f70&"
import script from "./OutputsTable.vue?vue&type=script&lang=js&"
export * from "./OutputsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports